// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"ZLPlRVH1"};